export const isMobileDevice = () => /Mobi|Android|iPhone/i.test(navigator.userAgent);
